export default function StoreButtons({ className = "" }) {
    return (
        <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
            <a
                href="#"
                data-testid="appstore-btn"
                aria-label="App Store'dan indir"
                className="btn-neon btn-cyan group inline-flex items-center gap-3 px-5 py-3.5 rounded-xl bg-white text-[#0a0a0c] font-medium text-sm border border-white/10"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <span className="flex flex-col items-start leading-tight">
                    <span className="text-[10px] uppercase tracking-[0.14em] opacity-60">İndirin</span>
                    <span className="text-[15px] font-display font-semibold">App Store</span>
                </span>
            </a>
            <a
                href="#"
                data-testid="playstore-btn"
                aria-label="Google Play'den indir"
                className="btn-neon btn-magenta group inline-flex items-center gap-3 px-5 py-3.5 rounded-xl bg-[#111115] text-white font-medium text-sm border border-white/10"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M3.6 2.27c-.36.36-.56.9-.56 1.6v16.27c0 .7.2 1.24.56 1.6l.07.07 9.12-9.12v-.36L3.67 2.2l-.07.07z" fill="#00F0FF"/>
                    <path d="M15.8 15.36l-3.04-3.04v-.36l3.04-3.04.07.04 3.6 2.05c1.03.58 1.03 1.54 0 2.13l-3.6 2.05-.07.17z" fill="#FF2D92"/>
                    <path d="M15.87 15.32L12.72 12.17 3.6 21.29c.34.36.9.4 1.54.05l10.73-6.02" fill="#fff"/>
                    <path d="M15.87 9l-10.73-6c-.64-.36-1.2-.32-1.54.04l9.12 9.12L15.87 9z" fill="#fff" opacity="0.7"/>
                </svg>
                <span className="flex flex-col items-start leading-tight">
                    <span className="text-[10px] uppercase tracking-[0.14em] opacity-60">Deneyin</span>
                    <span className="text-[15px] font-display font-semibold">Google Play</span>
                </span>
            </a>
        </div>
    );
}
